<div class="overlay-user d-flex flex-column" [ngClass]="{ 'is-app': isApp }">
    <!-- h-100 -->
    <div *edpConditionalRegion="'pt.edp.edponline.contract.profile.edit'">
        <div *ngIf="isApp" class="user-profile-container">
            <a class="user-profile" (click)="editProfile()" [gaClickDatalayer]="'sidebarProfileUpdate'">
                {{ "edp.topbar.editprofile" | translate }}
            </a>
        </div>
    </div>

    <div class="overlay-user-header">
        <div class="d-flex">
            <div class="user-photo">
                <div class="user-avatar" (click)="switchEnvironment()">
                    <img *ngIf="user.photoURL" src="{{ user.photoURL }}" alt="User image" />
                    <span *ngIf="!user.photoURL" class="user-icon">
                        <i class="icon icon-edponline-Bop-081" [ngStyle]="{ color: levelColor }" aria-hidden="true"></i>
                    </span>
                </div>
            </div>

            <div class="user-info">
                <div class="user-name">{{ customerName.toLowerCase() }}</div>

                <div class="user-email">{{ user.email }}</div>

                <div *edpConditionalRegion="'pt.edp.edponline.contract.profile.edit'">
                    <a *ngIf="!isApp" class="user-profile" (click)="editProfile()" [gaClickDatalayer]="'sidebarProfileUpdate'">
                        {{ "edp.topbar.editprofile" | translate }}
                    </a>
                </div>
            </div>
        </div>

        <div *ngIf="hasEmployeeBenefit" class="icon-discount-collaborator">
            <span class="icon-bottom mb-4">
                <i class="icon-edponline-Bra-134" aria-hidden="true"></i>
                <span class="discount">{{ "ContractItem.WorkerDiscount" | translate }}</span>
            </span>
        </div>
    </div>

    <div *edpConditionalRegion="'pt.edp.edponline.contract.profile.user.complete.pt'" class="overlay-user-profile">
        <edp-overlay-complete-profile></edp-overlay-complete-profile>
    </div>

    <div id="edp-tour-user-local" class="overlay-user-places">
        <p *edpConditionalRegion="'pt.edp.edponline.contract.profile.user.contracts.pt'" class="overlay-user-places-title">
            {{ "pt.edp.edponline.contract.list.consumption.title" | translate }}
        </p>

        <p *edpConditionalRegion="'pt.edp.edponline.contract.profile.user.contracts.es'" class="overlay-user-places-title-es">
            {{ "pt.edp.edponline.contract.list.consumption.title" | translate }}
        </p>

        <div *edpConditionalRegion="'pt.edp.edponline.contract.profile.user.contracts.pt'">
            <!-- FIRST OPTION - Show both contracts Mix. -->
            <div *ngIf="userContracts.length > 0 && thirdPartyContracts.length > 0" class="d-flex flex-column">
                <div class="d-flex justify-content-start align-items-center">
                    <div class="d-flex justify-content-start align-items-baseline mr-3">
                        <span class="overlay-user-places-length">{{ userContracts.length }}</span>
                        <span class="overlay-user-places-legend">
                            {{
                                userContracts.length === 1
                                    ? ("pt.edp.edponline.user.yourPlace" | translate)
                                    : ("pt.edp.edponline.user.yourPlaces" | translate)
                            }}
                        </span>
                    </div>
                    <div class="d-flex justify-content-start align-items-baseline">
                        <span class="overlay-user-places-length">{{ thirdPartyContracts.length }}</span>
                        <span class="overlay-user-places-legend">
                            {{
                                thirdPartyContracts.length === 1
                                    ? ("pt.edp.edponline.user.thirdPartyPlace" | translate)
                                    : ("pt.edp.edponline.user.thirdPartyPlaces" | translate)
                            }}
                        </span>
                    </div>
                </div>

                <div *ngIf="managedBy" class="overlay-user-places-manage">
                    <div class="icon">
                        <i class="icon-edponline-Bra-025" aria-hidden="true"></i>
                    </div>
                    <span class="subtitle">
                        {{ "pt.edp.edponline.overlay.contract.managedBy.description" | translate }}
                        {{ contractManagedByName }}
                    </span>
                </div>
            </div>
            <!-- END FIRST OPTION -->

            <!-- SECOND OPTION - Number of active contracts or contracts in activation less than or equal to six. -->
            <div
                *ngIf="userContracts.length > 0 && userContracts.length <= 6 && thirdPartyContracts.length === 0"
                class="container-fluid px-0"
            >
                <div class="row no-gutters">
                    <div *ngFor="let userContract of userContracts" class="col-6 mb-3">
                        <div class="d-flex flex-column h-100">
                            <div class="overlay-user-places-contract">{{ userContract.Nickname }}</div>
                            <div class="overlay-user-places-legend mt-auto">
                                {{ "AddContract.NIF" | translate }} {{ userContract.OwnerNif }}
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="managedBy" class="overlay-user-places-manage">
                    <div class="icon">
                        <i class="icon-edponline-Bra-025" aria-hidden="true"></i>
                    </div>
                    <span class="subtitle">
                        {{ "pt.edp.edponline.overlay.contract.managedBy.description" | translate }}
                        {{ contractManagedByName }}
                    </span>
                </div>
            </div>

            <div
                *ngIf="thirdPartyContracts.length > 0 && thirdPartyContracts.length <= 6 && userContracts.length === 0"
                class="container-fluid px-0"
            >
                <div class="row no-gutters">
                    <div *ngFor="let thirdPartyContract of thirdPartyContracts" class="col-6 mb-3">
                        <div class="d-flex flex-column h-100">
                            <div class="overlay-user-places-contract">{{ thirdPartyContract.Nickname }}</div>
                            <div class="overlay-user-places-legend mt-auto">
                                {{ "AddContract.NIF" | translate }} {{ thirdPartyContract.OwnerNif }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END SECOND OPTION -->

            <!-- THIRD OPTION - Number of active contracts or contracts in activation greater than six. -->
            <div *ngIf="userContracts.length > 6 && thirdPartyContracts.length === 0" class="container-fluid px-0">
                <div class="d-flex justify-content-start align-items-baseline">
                    <span class="overlay-user-places-length">{{ userContracts.length }}</span>
                    <span class="overlay-user-places-legend">{{ "pt.edp.edponline.overlay.contract" | translate }}</span>
                </div>

                <div class="d-flex justify-content-start align-items-start mt-2">
                    <span class="overlay-user-places-legend">{{ "AddContract.NIF" | translate }} {{ userContracts[0].OwnerNif }}</span>
                </div>

                <div *ngIf="managedBy" class="overlay-user-places-manage">
                    <div class="icon">
                        <i class="icon-edponline-Bra-025" aria-hidden="true"></i>
                    </div>
                    <span class="subtitle">
                        {{ "pt.edp.edponline.overlay.contract.managedBy.description" | translate }}
                        {{ contractManagedByName }}
                    </span>
                </div>

                <div *ngIf="thirdPartyContracts.length > 6 && userContracts.length === 0" class="container-fluid px-0">
                    <div class="row">
                        <div class="col">
                            <p>
                                <span class="contrats-number">{{ thirdPartyContracts.length }}</span>
                                <span class="contract-text">
                                    {{ "pt.edp.edponline.overlay.contract.third" | translate }}
                                </span>
                                <br />

                                <span class="nif">
                                    {{ "pt.edp.edponline.overlay.user.dni" | translate }} {{ thirdPartyContracts[0].OwnerNif }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END THIRD OPTION -->
        </div>

        <div *edpConditionalRegion="'pt.edp.edponline.contract.profile.user.contracts.es'">
            <div *ngFor="let contract of contractsEs">
                <div class="d-flex es-contracts-wrapper">
                    <div class="d-flex align-items-center mr-2">
                        <i class="es-contracts-icon" [ngClass]="[contract.contractIcon]" aria-hidden="true"></i>
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                        <p class="es-contracts-title">{{ contract.supplyCity }}</p>
                        <p class="es-contracts-street">{{ contract.supplyStreet }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="overlay-user-body flex-grow-1">
        <div *edpConditionalRegion="'pt.edp.edponline.contract.profile.actions.pt'">
            <div class="overlay-user-mgm pl-4" (click)="moreInfo()">
                <div class="d-flex justify-content-start align-items-top">
                    <div class="d-flex flex-column">
                        <span class="overlay-user-more-info-title">{{ "pt.edp.edponline.overlay.contract.update.title" | translate }}</span>
                        <span class="overlay-user-more-info-message">
                            {{ "pt.edp.edponline.overlay.contract.update.description" | translate }}
                        </span>
                    </div>
                    <span class="overlay-user-more-info-icon">
                        <i class="icon-edponline-Bop-033" aria-hidden="true"></i>
                    </span>
                </div>
            </div>

            <div
                class="overlay-user-card"
                (click)="openHouseDetails()"
                [gaClickDatalayer]="'sidebarConsumptionPlaceUpdate'"
                [extraGaClickDatalayer]="getExtraGaClickDatalayer()"
                *ngIf="statusMoonshot$ | async as statusMoonshot"
                [class.overlay-user-card--dark]="
                    (statusMoonshot.started && !statusMoonshot.completed) ||
                    (termsAndConditions && !statusMoonshot.started && !statusMoonshot.completed)
                "
            >
                <ng-container *ngIf="statusMoonshot.completed || !isBetaUser">
                    <span>{{ "pt.edp.edponline.overlay.house.details" | translate }}</span>
                    <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                </ng-container>

                <ng-container *ngIf="isBetaUser">
                    <ng-container *ngIf="!termsAndConditions && !statusMoonshot.started">
                        <div class="overlay-user-card-body">
                            <span>{{ "pt.edp.edponline.overlay.house.configuration.moonshot.description" | translate }}</span>
                            <p class="overlay-user-card-body-label">
                                {{ "pt.edp.edponline.overlay.house.configuration.moonshot.label" | translate }}
                            </p>
                        </div>
                        <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                    </ng-container>

                    <ng-container
                        *ngIf="
                            (statusMoonshot.started && !statusMoonshot.completed) ||
                            (termsAndConditions && !statusMoonshot.started && !statusMoonshot.completed)
                        "
                    >
                        <div class="overlay-user-card-proccess">
                            <div class="overlay-user-card-proccess--loader">
                                <i class="icon-edponline-house-solid" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="overlay-user-card-body overlay-user-card--dark-body">
                            <div class="overlay-user-card--dark-body-title">
                                <p>{{ "pt.edp.edponline.overlay.house.configuration.moonshot.description" | translate }}</p>
                                <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                            </div>

                            <p class="overlay-user-card--dark-body-subtitle">
                                {{ "pt.edp.edponline.overlay.house.configuration.moonshot.process.description" | translate }}
                            </p>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <div *ngIf="showGiveFeedbackButton" class="overlay-user-card">
                <div class="overlay-user-card-content d-flex align-items-center justify-content-between" (click)="onGiveFeedBack()">
                    <span>{{ "pt.edp.edponline.overlay.user.give.feedback.button.label" | translate }}</span>
                    <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                </div>
            </div>

            <div *ngIf="b2bUrl && !isApp" class="overlay-user-card" (click)="openB2B(b2bUrl)">
                <span>{{ "pt.edp.edponline.overlay.contract.manage-company" | translate }}</span>
                <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
            </div>

            <div id="edp-tour-user-consents" class="overlay-user-card overlay-user-terms flex-column">
                <div class="overlay-user-card-content d-flex align-items-center justify-content-between" (click)="openTerms()">
                    <span>{{ "pt.edp.edponline.overlay.communications.consents" | translate }}</span>
                    <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                </div>
                <ng-container *ngIf="!!isApp && !!hasAppRecognition">
                    <div
                        class="overlay-user-card-content d-flex align-items-center justify-content-between mt-5"
                        (click)="goToProfileRecognition()"
                    >
                        <span>{{ "pt.edp.edponline.overlay.recognition.title" | translate }}</span>
                        <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                    </div>
                </ng-container>
            </div>

            <div class="overlay-user-card d-lg-none" (click)="openModalLanguages()">
                <div class="overlay-user-card-content">
                    <div class="d-flex justify-content-between">
                        <span>{{ "pt.edp.edponline.language.title" | translate }}</span>
                        <i class="icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                    </div>
                    <span class="actual-language">{{ userLanguageLabel }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="overlay-footer">
        <button (click)="logout()" type="button" class="btn btn-primary">
            <span class="text-botton">{{ "edp.menu.logoff" | translate }}</span>
        </button>
    </div>
</div>
